// Served at the site root by default. To host under a sub-path (e.g. /ca),
// set PUBLIC_URL at build time and the router will pick it up automatically.
export const APP_BASENAME = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

export const paths = {
  home: "/",
  about: "/about",
  login: "/login",
  signup: "/signup",
  otpVerify: "/otpVerify",
  registrationSuccess: "/login_success",
  registrationSuccessSignup: "/registration_success",
  dashboard: "/dashboard",
  leaderboard: "/leaderboard",
  rule: "/rule",
  rulebook: "/rulebook",
  task: "/task",
  contact: "/contact",
  faq: "/faq",
  adminLogin: "/admin/login",
  adminDashboard: "/admin/dashboard",
  adminCas: "/admin/cas",
  adminTasks: "/admin/tasks",
  adminSubmissions: "/admin/submissions",
  adminLeaderboard: "/admin/leaderboard",
  adminAnnouncements: "/admin/announcements",
};

/** Build a full URL from an app-relative path (for sharing/copy). */
export function resolveAppUrl(relativePath) {
  if (!relativePath) {
    return `${window.location.origin}${APP_BASENAME}`;
  }
  if (/^https?:\/\//i.test(relativePath)) {
    return relativePath;
  }
  const path = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;
  return `${window.location.origin}${APP_BASENAME}${path}`;
}

/** Hash link on the landing page, e.g. #aboutus */
export function homeHash(hash) {
  return { pathname: paths.home, hash: hash.replace(/^#/, "") };
}
